import { motion } from 'motion/react';
import { useSuccessGamblingContext } from '@/components/success-gambling/context';
import '@/components/success-gambling/components/link/link.css';

export default function Link() {
  const { company } = useSuccessGamblingContext();

  return (
    <div data-testid='gambling-link' className='success-gambling-link'>
      <div className='success-gambling-link__items'>
        <motion.a
          href={company.href}
          rel='noreferrer'
          target='_blank'
          aria-label='Open email application'
          className='success-gambling-link__button'
          whileTap={{ scale: 1.025 }}
        >
          {company.label}
        </motion.a>
      </div>
    </div>
  );
}
